export class TituloEleitor {
  Numero: string;
  ZonaEleitoral: string;
  SecaoEleitoral: string;
  UfEleitoral?: string;
  constructor() {}
}
